export default class Form {
  constructor() {
    // file upload button
    const formInputs = document.querySelectorAll('.wpcf7-file');
    formInputs.forEach(el => {
      el.onchange = function () {
        const id = this.getAttribute('id');
        const fileName = document.getElementById(id+'-fileName');
        fileName.innerHTML = this.files[0].name;
        this.closest('.js-inputFile').classList.add('changed');
      };
    });

    const clearBtn = document.querySelectorAll('.js-clearFile')
    clearBtn.forEach(btn => {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        const id = this.getAttribute('data-target');
        const input = document.getElementById(id);
        const fileName = document.getElementById(id+'-fileName');
        this.closest('.js-inputFile').classList.remove('changed');
        input.value = '';
        fileName.innerHTML = '';
      }, false);
    });

    const subject = document.getElementById('form-subject');
    if (subject) {
      subject.onchange = function () {
        document.querySelectorAll('.tab-content').forEach(tab => {
          tab.classList.remove('is-visible', 'is-disabled');
        });
        document.getElementById(this.value).classList.add('is-visible');
      }

    }
  }
}
